import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  TemplateRef,
  ViewChild,
  inject,
  viewChild,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { BaseComponent } from '@app/components/base/base.component';
import { AuthService } from '@app/common/auth.service';
import { ModalService } from '@app/components/modal/modal.service';
import { WholeSale } from '@app/core/model/CoreModel';
import { StandardQuoteService } from '@app/pages/quote/standard-quote/standard-quote-service.service';
import { insurance, models } from '@app/pages/quote/standard-quote/model/standard-quote.model';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { finalize } from 'rxjs/operators';


@Component({
  template: ""
})
export class DealsStandardQuoteWrapperComponent
  extends BaseComponent
  implements OnInit, OnChanges {
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  readonly extendValidityModalTemplate = viewChild<TemplateRef<unknown>>('extendValidityModalTemplate');
  isLoading: boolean = false;
  showRow: number = 1;
  dealName: string = '';
  title: string = 'Eliminar propuesta';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  extendValidityModal = {
    title: 'Extender vigencia',
    subtitle: '',
    btn1: 'Cancelar',
    btn2: 'Confirmar',
  };
  idDeal: number;
  currentPageIndex: number = 0;
  pageSize: number = 8;
  pageIndex: number = 0;
  @Input() status: any;

  @Output() setValueInService: EventEmitter<any> = new EventEmitter();
  @Output() dealsUpdate: EventEmitter<any> = new EventEmitter();

  @Input() deals: any[] = [];
  @Input() idQuote: any;
  @Input() isValidForm: boolean;
  @Input() creationUser: any;
  @Input() model: models;
  @Input() validBranch: any;

  wholeSale: WholeSale;
  isEditable: boolean = true;
  userId: string = '';
  extendingDealId: number | null = null;
  pendingExtendDealId: number | null = null;

  private readonly quoteService = inject(StandardQuoteService);
  public readonly authService = inject(AuthService);
  private readonly modalService = inject(ModalService);
  private readonly router = inject(Router);
  constructor(route: ActivatedRoute, menu: MenusServices, notification: NotificationService) {
    super(route, menu, notification);
  }

  ngOnInit() {
    this.userId = this.authService.currentUserIds;
  }

  ngOnChanges(changes: any) {
    if(changes.model?.currentValue) {
      const formData : any = this.quoteService.formData;
      if(formData) {
        this.isEditable = formData?.model?.enabled || this.model?.enabled;
      }
    }
  }

  addNewDeal() {
    this.setValueInService.emit();
    if (this.idQuote) {
      this.trackerService.track("UserAddNewDeal", {
        quoteId: this.idQuote,
      });
      this.dealsUpdate.emit(this.deals);
      this.router.navigate([
        `standard-quote/edit-quote/${this.idQuote}/new-deal`,
      ]);
    } else {
      this.trackerService.track("UserAddNewDealOnNewQuote", {});
      this.router.navigate([`standard-quote/new-quote/new-deal`]);
    }
  }

  editDeal(index: number) {
    // this.setValueInService.emit();
    if (this.idQuote) {
      this.trackerService.track("UserEditDeal", {
        quoteId: this.idQuote,
        dealId: index,
      });
      this.dealsUpdate.emit(this.deals);
      this.router.navigate([
        `standard-quote/edit-quote/${this.idQuote}/edit-deal/${index}`,
      ]);
    } else {
      this.router.navigate([`standard-quote/new-quote/edit-deal/${index}`]);
    }
  }

  deleteDeal() {
    this.closeModal();
    this.isLoading = true;

    this.quoteService.deleteDeal(this.idQuote, this.idDeal).subscribe({
      next: (response) => {
        this.trackerService.track("UserDeleteDealSuccess", {
          quoteId: this.idQuote,
          dealId: this.idDeal,
        });
        this.deals = this.deals.filter((i) => i.id != this.idDeal);
        this.dealsUpdate.emit(this.deals);
        this.isLoading = false;
      },
      error: (error) => {
        this.trackerService.track("UserDeleteDealError", {
          quoteId: this.idQuote,
          dealId: this.idDeal,
          error: error?.message ?? "",
        });
        this.showNotificationError(
          'Ha ocurrido un error al momento de eliminar propuesta'
        );
        this.isLoading = false;
      },
    });
  }

  openModalConfirmation(idDeal: number) {
    this.idDeal = idDeal;
    let deal = this.deals.find((i) => i.id == idDeal);
    this.dealName = `${this.quoteService.getFinancialProduct(
      deal.financialSetup.financialProduct
    )} ${deal.financialCondition.term} meses`;
    this.subtitle = `¿Confirma la eliminación de la propuesta "${this.dealName}"?`;
    this.trackerService.track("UserDeleteDeal", {
      quoteId: this.idQuote,
      dealId: this.idDeal,
    });
    this.modalService.component = this.modalTemplate;
    this.modalService.openModal();
  }

  closeModal() {
    this.modalService.closeModal();
  }

  cancelDeleteDeal(){
    this.trackerService.track("UserCancelDeleteDeal", {
      quoteId: this.idQuote,
      dealId: this.idDeal,
    });
    this.modalService.closeModal();
  }

  duplicateDeal(idDeal: any) {
    this.trackerService.track("UserDuplicateDeal", {
      quoteId: this.idQuote,
      dealId: idDeal,
    });
    const newDeal = this.deals.find((i) => i.id == idDeal);
    const dealDuplicate = {
      ...newDeal,
      id: null,
      creationDate: null,
      updatedDate: null,
      validityEndDate: null,
      valid: null,
      minQuoteValidityDays: null,
      validityExtensionApplied: false,
      isSelected: false,
      financialSetup: {
        ...newDeal.financialSetup,
        creationDate: null,
        updatedDate: null,
      },
      financialCondition: {
        ...newDeal.financialCondition,
        creationDate: null,
        updatedDate: null,
      },
      standardFinancialSetup: {
        id: null,
        creationDate: null,
        updatedDate: null,
        ...newDeal.standardFinancialSetup,
      },
      insuranceDeals: [],
      result: null,
      // ✅ Clonar todo el seguro pero limpiar solo los datos calculados (igual que el backend)
      insurance: newDeal.insurance ? {
        ...newDeal.insurance,
        id: null,
        creationDate: null,
        updatedDate: null,
        packageList: null,
        standardQuoteInsurancePayments: [],
        insuranceAmount: null,
        requestId: null,
        insuranceId: null,
      } : null,
      payments: [],
      grace: this.getGrace(newDeal.grace),
      specialPayments: this.getSpecialPayments(newDeal.specialPayments),
      clonedPendingRecalculate: true,
    };
    this.quoteService.duplicateDeal = dealDuplicate;
    this.addNewDeal();
  }

  private formatExtendedValidityDate(
    validityEndDate: string | Date | null | undefined,
    days: number,
  ): string {
    if (!validityEndDate) {
      return '';
    }
    const date = new Date(validityEndDate);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const baseDate = date.getTime() < Date.now() ? new Date() : date;
    baseDate.setUTCDate(baseDate.getUTCDate() + days);
    return baseDate.toLocaleDateString('es-MX', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC',
    });
  }

  extendDealValidity(idDeal: number) {
    if (!this.idQuote || this.extendingDealId === idDeal || this.pendingExtendDealId !== null) {
      return;
    }
    const deal = this.deals.find((i) => i.id == idDeal);
    if (!deal) {
      return;
    }
    const modalTemplate = this.extendValidityModalTemplate();
    if (!modalTemplate) {
      return;
    }
    this.pendingExtendDealId = idDeal;
    const days = deal.minQuoteValidityDays ?? 30;
    const extendedDate = this.formatExtendedValidityDate(
      deal.validityEndDate,
      days,
    );
    this.extendValidityModal.subtitle = extendedDate
      ? `Cotización vencida. ¿Seguro que desea extender la vigencia de esta cotización hasta el ${extendedDate} (${days} días)?`
      : `Cotización vencida. ¿Seguro que desea extender la vigencia de esta cotización por ${days} días?`;
    this.modalService.component = modalTemplate;
    this.modalService.openModal();
  }

  confirmExtendDealValidity() {
    const idDeal = this.pendingExtendDealId;
    this.pendingExtendDealId = null;
    this.modalService.closeModal();
    if (idDeal != null) {
      this.executeExtendDealValidity(idDeal);
    }
  }

  cancelExtendDealValidity() {
    this.pendingExtendDealId = null;
    this.modalService.closeModal();
  }

  private executeExtendDealValidity(idDeal: number) {
    this.extendingDealId = idDeal;
    this.quoteService
      .extendStandardDealValidity(this.idQuote, idDeal)
      .pipe(
        finalize(() => {
          this.extendingDealId = null;
        })
      )
      .subscribe({
        next: (response) => {
          const payload = response?.data;
          const targetDealId = payload?.dealId ?? idDeal;
          this.deals = this.deals.map((deal) =>
            deal.id === targetDealId
              ? {
                  ...deal,
                  validityEndDate: payload?.validityEndDate ?? deal.validityEndDate,
                  valid: payload?.valid ?? deal.valid,
                  minQuoteValidityDays:
                    payload?.minQuoteValidityDays ?? deal.minQuoteValidityDays,
                  validityExtensionApplied:
                    payload?.validityExtensionApplied ?? true,
                }
              : deal
          );
          this.dealsUpdate.emit(this.deals);
          if (this.quoteService.formData) {
            this.quoteService.formData.standardQuoteDeals = this.deals as any;
          }
          this.showNotificationSuccess(
            'Vigencia de la propuesta extendida correctamente.'
          );
        },
        error: (error) => {
          const msg =
            error?.error?.errors?.[0] ??
            'No se pudo extender la vigencia de la propuesta.';
          this.showNotificationError(typeof msg === 'string' ? msg : String(msg));
        },
      });
  }


  duplicateInsurance(insurance: insurance) {
    if (!insurance) return null
    const coverageListModel = insurance ? insurance.packageList ?
      insurance.packageList.coverageListModel
        .map((coverage: any) => {
          return {...coverage, id: null, creationDate: null, updatedDate: null}
        }) : null : null;
    const packageList = insurance ? insurance.packageList : null;
    return {
      ...insurance,
      id: null,
      packageList: {
        ...packageList,
        id: null,
        creationDate: null,
        updatedDate: null,
        coverageListModel: coverageListModel,
        standardQuoteInsurancePayments: []
      }
    };
  }

  onChangeSelected(index: number) {
  }

  changeDesign(selected: number) {
    this.showRow = selected;
  }

  getPayments(payments: any) {
    if (!payments) return null
    return payments.map((payment: any) => {
      return {...payment, id: null, creationDate: null, updatedDate: null};
    });
  }

  getGrace(grace: any) {
    if (!grace) return null
    return grace.map((grace: any) => {
      return {...grace, id: null, creationDate: null, updatedDate: null};
    });
  }

  getSpecialPayments(specialPayments: any) {
    if (!specialPayments) return null
    return specialPayments.map((specialPayment: any) => {
      return {...specialPayment, id: null, creationDate: null, updatedDate: null};
    });
  }

  isSelected(id: number) {
    this.trackerService.track("UserSelectDeal", {
      quoteId: this.idQuote,
      dealId: id,
    });
    const deals = this.deals.map((i) => {return {...i, isSelected: i.id == id ? !i.isSelected : i.isSelected}})
    this.dealsUpdate.emit(deals);
  }

  get paginatedDeals(): any[] {
    const startIndex = this.pageIndex * this.pageSize;
    return this.deals.slice(startIndex, startIndex + this.pageSize);
  }

  // Evento cuando se cambia de página
  onPageChange(event: { pageIndex: number, pageSize: number }) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

}
